import { Cart, CartSetShippingAddressAction } from "@commercetools/platform-sdk"
import { JOGGResponse, ShippingAddressForm } from "@jog/types"

import { handleCartError } from "../helper"
import { JoggApiOption } from "./client"

export const addShippingAddressBase = ({ client }: Pick<JoggApiOption, "client">) => {
    return async (
        cartId: string,
        version: number,
        shippingAddress: ShippingAddressForm
    ): Promise<JOGGResponse<Cart>> => {
        const action: CartSetShippingAddressAction = {
            action: "setShippingAddress",
            address: {
                country: shippingAddress.country,
                firstName: shippingAddress.name,
                lastName: `${shippingAddress.insertion || ""} ${shippingAddress.familyName}`.trim(),
                postalCode: shippingAddress.postalCode,
                streetNumber: shippingAddress.houseNumber,
                streetName: shippingAddress.streetName,
                city: shippingAddress.city,
                additionalStreetInfo: shippingAddress.addition,
                phone: shippingAddress.phoneNumber,
                email: shippingAddress.email,
                additionalAddressInfo: shippingAddress.psfKey || "",
            },
        }

        const request = (version: number) =>
            client.execute({
                method: "POST",
                uri: `/ctp/carts/${cartId}`,
                body: {
                    version: version,
                    actions: [action],
                },
            })
        return handleCartError(request, version, 5)
    }
}
